export { default } from './FocusLock.vue';